import { render } from "./scroll.vue?vue&type=template&id=15d5dbe4"
import script from "./scroll.vue?vue&type=script&lang=js"
export * from "./scroll.vue?vue&type=script&lang=js"

import "./scroll.vue?vue&type=style&index=0&id=15d5dbe4&lang=css"

import exportComponent from "D:\\workspace_front\\syb\\syb_webchat\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__